export default __webpack_public_path__ + "static/media/dots-vertical.3238d1a4.svg";